import React from 'react';
import { Button } from './Button';
import { ArrowRightIcon } from 'lucide-react';
export const CTA = () => {
  return <section className="py-16 bg-gradient-to-r from-orange-600 to-red-600 text-white" data-id="element-120">
      <div className="container mx-auto px-4" data-id="element-121">
        <div className="max-w-4xl mx-auto text-center" data-id="element-122">
          <h2 className="text-3xl md:text-5xl font-bold mb-8" data-id="element-123">
            Haz clic ahora. No pienses.
          </h2>
          <p className="text-xl md:text-2xl mb-8" data-id="element-124">
            Haz lo que ya sabes que es correcto.
          </p>
          <p className="text-lg mb-12 max-w-2xl mx-auto" data-id="element-125">
            Porque tú no naciste para sobrevivir.
            <br data-id="element-126" />
            <br data-id="element-127" />
            Naciste para tener el control. Y todo eso empieza hoy.
          </p>
          <div className="flex flex-col items-center" data-id="element-128">
            <Button showPrice href="https://jancinas.com/checkouts/cn/hWN5NlkHONW0RzioeC4WJl5d/es-cl?_r=AQAB_muHi4WYbjqTrBznEaayCCMWWHCjPuTB_g6JEDp4-0I&preview_theme_id=186408665457" data-id="element-129">
              <span className="flex items-center" data-id="element-130">
                Da el primer paso hacia tu libertad financiera
                <ArrowRightIcon size={20} className="ml-2" data-id="element-131" />
              </span>
            </Button>
          </div>
        </div>
      </div>
    </section>;
};